module.exports = __webpack_public_path__ + "assets/5363d7372d7a073a3c3235601e822da6.mp3";